import styled from "@emotion/styled";
import { Building2, UserRound } from "lucide-react";
import { DomainOriginType } from "@porchpass/api-client";
import { getApplicationOriginStyle } from "src/constants/applicationOrigins";

const BadgeWrapper = styled.div<{
  backgroundColor: string;
  textColor: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 5px;
  color: ${({ textColor }) => textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  gap: 6px;
  max-height: 20px;
  padding: 4px 6px;
  white-space: nowrap;
  width: fit-content;
  flex-shrink: 0;

  svg {
    flex-shrink: 0;
  }
`;

interface ApplicationOriginBadgeProps {
  origin?: string | null;
}

export const ApplicationOriginBadge = ({
  origin,
}: ApplicationOriginBadgeProps) => {
  if (!origin || origin === DomainOriginType.OriginDigifi) return null;

  const style = getApplicationOriginStyle(origin);
  if (!style) return null;

  const Icon = origin === DomainOriginType.OriginDGA ? Building2 : UserRound;

  return (
    <BadgeWrapper
      backgroundColor={style.backgroundColor}
      textColor={style.textColor}
    >
      <Icon size={12} strokeWidth={2.25} />
      {style.label}
    </BadgeWrapper>
  );
};
